export const isNumberArray = (arr: any[]): arr is number[] => {
  return arr.every((item) => typeof item === "number");
};
